import { IconCircleXFilled, IconTrash } from '@tabler/icons-react';
import { PhotoProvider } from 'react-photo-view';
import { ActionIcon, Box, Group, ScrollArea } from '@mantine/core';

import 'react-photo-view/dist/react-photo-view.css';

import { ChatAttachmentPreview } from './chat-attachment-preview';
import { useChatComposerContext } from './contexts';

interface IChatAttachmentComposerProps {
  size?: 'sm' | 'md';
}

export default function ChatAttachmentComposer({
  size = 'md',
}: IChatAttachmentComposerProps) {
  const { attachments, removeAttachment, clearAttachments } =
    useChatComposerContext();

  const attachmentExists = attachments.length > 0;
  const boxSize = size === 'md' ? 64 : 52;

  return (
    <Group justify="space-between" bg="white" pl="sm" pr="0.4rem">
      <ScrollArea flex={1} scrollbarSize={8}>
        <PhotoProvider>
          <Group gap="0.3rem" wrap="nowrap">
            {attachments.map((meta) => (
              <Box
                key={meta.id}
                pos="relative"
                w={boxSize}
                h={boxSize}
                bg="gray.2"
                p="0.25rem"
                my="xs"
                bdrs="sm"
              >
                <ChatAttachmentPreview fileMeta={meta} />

                <ActionIcon
                  variant="transparent"
                  pos="absolute"
                  top={-8}
                  right={-8}
                  onClick={() => removeAttachment(meta.id)}
                >
                  <IconCircleXFilled size={18} color="gray" />
                </ActionIcon>
              </Box>
            ))}
          </Group>
        </PhotoProvider>
      </ScrollArea>

      {attachmentExists && (
        <ActionIcon
          variant="transparent"
          onClick={clearAttachments}
          className="cursor-pointer"
        >
          <IconTrash size={20} color="red" />
        </ActionIcon>
      )}
    </Group>
  );
}
